import { render, staticRenderFns } from "./CardComment.vue?vue&type=template&id=65b68eb2&scoped=true&"
import script from "./CardComment.vue?vue&type=script&lang=js&"
export * from "./CardComment.vue?vue&type=script&lang=js&"
import style0 from "./CardComment.vue?vue&type=style&index=0&id=65b68eb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b68eb2",
  null
  
)

export default component.exports